import { render, staticRenderFns } from "./ProjectReportsTable.vue?vue&type=template&id=2d49c272&"
import script from "./ProjectReportsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports